<template>
  <!-- <router-link :to="liveDetailUrl"> -->
  <div class="live-item">
    <router-link :to="liveDetailUrl">
      <div class="live-left">
        <img
          v-if="live.liveStatus == '1'"
          alt
          class="item-image"
          :src="live.coverPath || noStartImage"
        />
        <img
          v-else-if="live.liveStatus == '0' && live.streamStatus == '0'"
          alt
          class="item-image"
          :src="live.coverPath || noSignImage"
        />
        <img v-else alt class="item-image" :src="live.coverPath || defaultImage" />
      </div>
    </router-link>
    <div class="live-right">
      <router-link :to="liveDetailUrl">
        <div class="title">
          <p>{{ live.liveTitle }}</p>
        </div>
        <div class="start-time">
          <!-- <i class="iconfont icon-shizhong" /> -->
          <p>{{ live.startTime | formatDate('YYYY-MM-DD HH:mm') }}</p>
        </div>
      </router-link>
      <template v-if="deviceUuid !== ''">
        <div
          v-if="live.liveType !== 4 || live.streamStatus === 0"
          class="operate"
          @click.prevent="startLive"
        >
          <div class="startLive">
            <!-- <i class="iconfont icon-zhibo" /> -->
            <p>开启直播</p>
          </div>
        </div>
        <div v-else class="operate-not">
          <div class="startLive">
            <!-- <i class="iconfont icon-zhibo" /> -->
            <p>开启直播</p>
          </div>
        </div>
      </template>
    </div>
  </div>
  <!-- </router-link> -->
</template>

<script>
const copy = require('copy-text-to-clipboard');

export default {
  name: 'live-list-item',
  data() {
    return {
      defaultImage: require('../../assets/default-image.png'),
      noSignImage: require('../../assets/no-sign-live.gif'),
      noStartImage: require('../../assets/no-start-live.gif')
    };
  },
  props: {
    live: {
      type: Object,
      required: true
    },
    deviceUuid: {
      type: String,
      required: true
    }
  },
  computed: {
    liveDetailUrl() {
      // : `/detail/${this.live.id}/${this.live.liveId}/${this.live.streamCode}`;
      return this.live.stages === 1
        ? ''
        : `/detail/${this.live.liveId}/${this.live.streamCode}/${this.live.schoolName}`;
    },
    statusText() {
      let text = '直播中';
      if (this.live.stages === 1) {
        text = '已结束';
      } else if (this.live.stages === 2) {
        text = '等待直播';
      }
      return text;
    }
  },
  methods: {
    copyClickHandler() {
      if (this.live.liveType === '1') {
        const result = copy(this.live.streamCodeDevice);
        if (result) {
          this.$createToast({
            txt: '直播码复制成功',
            type: 'correct'
          }).show();
        }
      } else {
        const result = copy(this.live.pushPath);
        if (result) {
          this.$createToast({
            txt: '推流地址复制成功',
            type: 'correct'
          }).show();
        }
      }
    },
    deleteClickHandler() {
      if (this.live.stages === 3) {
        this.$createToast({
          txt: '正在直播中...<br />请直播结束后再删除',
          type: 'warn'
        }).show();
        return;
      }

      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        // title: '提示',
        content: '确定要删除这个直播吗',
        confirmBtn: {
          text: '确定',
          active: true
        },
        cancelBtn: {
          text: '取消',
          active: false
        },
        onConfirm: () => {
          this.$emit('delLive', this.live);
        },
        onCancel: () => {}
      }).show();
    },
    shareClickHandler() {
      const href = this.$getLiveShareUrl({
        id: this.live.id,
        liveId: this.live.liveId,
        streamCode: this.live.streamCode,
        userPhone: this.live.userPhone
      });
      const shareLive = {
        title: this.live.title,
        content: '点击观看课堂精彩内容',
        icon: this.$getShareIcon('live'),
        href
      };
      this.$share(this, shareLive);
    },
    startLive() {
      console.log('start-time', this.live.startTime);
      if (new Date().getTime() < new Date(this.live.startTime).getTime()) {
        this.$createDialog({
          type: 'confirm',
          icon: 'cubeic-alert',
          content: '确定要提前开启直播吗',
          confirmBtn: {
            text: '确定',
            active: true
          },
          cancelBtn: {
            text: '取消',
            active: false
          },
          onConfirm: () => {
            this.$emit('start-live', this.live);
          },
          onCancel: () => {}
        }).show();
      } else {
        this.$emit('start-live', this.live);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.live-item {
  padding: 8px 12px;
  background: #fff;
  display: flex;

  .live-left {
    img {
      width: 130px;
      height: 82px;
      border-radius: 3%;
      display: block;
      margin: 0;
    }
  }
  .live-right {
    flex: 1;
    margin-left: 10px;
    padding-top: 6px;
    overflow: hidden;
  }
  .iconfont {
    margin-right: 1px;
    font-size: 16px;
  }
  .icon-shizhong {
    color: #888;
    font-size: 14px;
  }
  .live-right .title {
    display: flex;
    color: #111;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 6px;
    height: 24px;
    align-items: center;
    p {
      padding: 1.7px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .live-right .streamCode {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin: 2px 0px;
  }

  .live-right .start-time {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #96989b;
    margin: 7px 0px;
  }

  .operate {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #1890ff;

    .startLive {
      border: 1px solid #1890ff;
      background-color: #e3f2ff;
      border-radius: 16px;
      padding: 8px 16px;
      font-size: 14px;
      color: #1890ff;
      display: flex;
      align-items: center;

      p {
        font-size: 12px;
        margin-left: 1px;
      }
    }
  }

  .operate-not {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .startLive {
      border: 1px solid #96989b;
      border-radius: 16px;
      padding: 8px 16px;
      font-size: 14px;
      color: #96989b;
      display: flex;
      align-items: center;

      p {
        font-size: 12px;
        margin-left: 1px;
      }
    }
  }
}
</style>
